"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { cj } from "../utils";
const DEFAULT_16_9_RATIO = 0.5617021276595745;
const YouTubeVideo = /*#__PURE__*/ React.forwardRef(function YouTubeVideo(_param, ref) {
    var { className = "", title, videoId, aspectRatio = DEFAULT_16_9_RATIO, startAt = 0, showAllRelatedVideos = false, controls = true, autoplay = false, muted = false, privacyMode = false } = _param, props = _object_without_properties(_param, [
        "className",
        "title",
        "videoId",
        "aspectRatio",
        "startAt",
        "showAllRelatedVideos",
        "controls",
        "autoplay",
        "muted",
        "privacyMode"
    ]);
    const baseUrl = privacyMode ? "https://www.youtube-nocookie.com/embed" : "https://www.youtube.com/embed";
    const urlParams = Object.entries({
        startAt,
        showAllRelatedVideos,
        controls,
        autoplay,
        muted
    }).map(([k, v])=>`${k}=${Number(v)}`).join("&");
    const iframeStyle = {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "auto"
    };
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        style: {
            paddingTop: `${aspectRatio * 100}%`
        },
        className: cj("w-embed-youtubevideo", className),
        ref: ref
    }), /*#__PURE__*/ React.createElement("iframe", {
        src: `${baseUrl}/${videoId}?${urlParams}`,
        title: title,
        allowFullScreen: true,
        scrolling: "no",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        style: iframeStyle
    }));
});
export default YouTubeVideo;
